import { defineCustomElement } from 'vue'
import SearchResults from '../components/SearchResults.vue'

export { registerTeaser, unregisterTeaser } from '../components/teasers/registry'
export type { TeaserMap } from '../components/teasers/registry'
export { registerComponent, unregisterComponent } from '../components/registry'
export type { ComponentMap, ComponentName } from '../components/registry'
export { useTranslate } from '../components/composables/useTranslate'
export { useClasses } from '../components/composables/useClasses'
export { defaultClasses, mergeClasses } from '../core/classes'
export type { Classes, ClassGroup, ClassOverrides } from '../core/classes'
export { default as SearchForm } from '../components/SearchForm.vue'
export { default as ResultPagination } from '../components/ResultPagination.vue'
export { default as TeaserSkeleton } from '../components/TeaserSkeleton.vue'
export { default as TeaserDefault } from '../components/teasers/TeaserDefault.vue'
export { h, defineComponent } from 'vue'
export type * from '../core/types'

export const SEARCH_RESULTS_TAG = 'agent-search-results'

/**
 * @deprecated The former tag, still rendered by the default template of the Pimcore bundle.
 * Upgrades like `<agent-search-results>` and warns once; use the new tag.
 */
export const LEGACY_SEARCH_RESULTS_TAG = 'va-search-results'

const FORWARDED_EVENTS = new Set(['agent-search-results', 'agent-search-result-click'])

const SearchResultsBase = defineCustomElement(SearchResults, { shadowRoot: false })

/**
 * Vue dispatches component emits as CustomEvent with `detail` holding the argument *array*.
 * The package's events carry a single payload object, so it is unwrapped into `detail` and bubbles,
 * which lets a page listen on `document`.
 */
export class SearchResultsElement extends SearchResultsBase {
    override dispatchEvent(event: Event): boolean {
        if (event instanceof CustomEvent && FORWARDED_EVENTS.has(event.type) && Array.isArray(event.detail)) {
            return super.dispatchEvent(new CustomEvent(event.type, { detail: event.detail[0], bubbles: true }))
        }

        return super.dispatchEvent(event)
    }
}

let legacyWarned = false

/** The deprecated tag; a custom element registry needs its own constructor per tag name. */
class LegacySearchResultsElement extends SearchResultsElement {
    override connectedCallback(): void {
        if (!legacyWarned) {
            legacyWarned = true
            console.warn(`[agent-search] <${LEGACY_SEARCH_RESULTS_TAG}> is deprecated, use <${SEARCH_RESULTS_TAG}>`)
        }

        super.connectedCallback()
    }
}

export function defineElements(): void {
    if (typeof customElements === 'undefined') {
        return
    }

    if (!customElements.get(SEARCH_RESULTS_TAG)) {
        customElements.define(SEARCH_RESULTS_TAG, SearchResultsElement)
    }

    if (!customElements.get(LEGACY_SEARCH_RESULTS_TAG)) {
        customElements.define(LEGACY_SEARCH_RESULTS_TAG, LegacySearchResultsElement)
    }
}

defineElements()
